import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { withStyles } from '@mui/styles'
import TextField from '@mui/material/TextField'

import lang from 'lang'
import BuhlBankLogo from '@assets/images/banking/buhlBank.svg?url'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const BankingTextInput = (props) => {
  const { classes, hideLogo, ...otherProps } = props
  return (
    <div className={classes.container}>
      <TextField
        variant="outlined"
        name={otherProps.name}
        type="text"
        label={otherProps.label}
        onChange={otherProps.onChange}
        defaultValue={otherProps.value}
        className={classes.textField}
      />
      { !hideLogo
      && <Tooltip
        title={lang.bankingBuhlBankInputTooltip}
        classes={{ tooltip: classes.tooltip }}>
        <div className={classes.logo}>
          <SVGIcon svg={BuhlBankLogo} width='80px' height='20px' />
        </div>
      </Tooltip>
      }
    </div>
  )
}

const styles = theme => ({
  container: {
    position: 'relative',
    marginBottom: '24px',
    '& .MuiInputBase-root:not(.Mui-focused):hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.disabledBorderColor,
        borderWidth: '1px',
      },
    },
  },
  logo: {
    position: 'absolute',
    right: 16,
    top: 14,
  },
  tooltip: {
    maxWidth: 200,
    marginRight: 50,
  },
  textField: {
    width: '100%',
  },
})

export default withStyles(styles)(BankingTextInput)
